/**
 * Quote Request Feature
 */
(function() {
  'use strict';

  const CONFIG = {
    webhookUrl: 'https://n8n.bizfound.com/webhook/quote-request',
    selectors: {
      modal: '#quote-request-modal',
      openButton: '#quote-request-btn',
      closeButtons: '[data-quote-modal-close]',
      form: '#quote-request-form',
      submitBtn: '#quote-submit-btn',
      errorContainer: '#quote-form-error',
      referenceDisplay: '#quote-reference',
      formState: '[data-quote-state="form"]',
      successState: '[data-quote-state="success"]'
    }
  };

  let isSubmitting = false;

  function init() {
    const modal = document.querySelector(CONFIG.selectors.modal);
    const openButton = document.querySelector(CONFIG.selectors.openButton);
    
    if (!modal) return;

    if (openButton) {
      openButton.addEventListener('click', openModal);
    }
    
    document.querySelectorAll(CONFIG.selectors.closeButtons).forEach(btn => {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display !== 'none') {
        closeModal();
      }
    });

    const form = document.querySelector(CONFIG.selectors.form);
    if (form) {
      form.addEventListener('submit', handleSubmit);
    }
  }

  function openModal() {
    const modal = document.querySelector(CONFIG.selectors.modal);
    if (!modal) return;
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      const firstInput = modal.querySelector('input:not([type="hidden"])');
      if (firstInput) firstInput.focus();
    }, 100);
  }

  function closeModal() {
    const modal = document.querySelector(CONFIG.selectors.modal);
    if (!modal) return;
    modal.style.display = 'none';
    document.body.style.overflow = '';
    setTimeout(resetModal, 300);
  }

  function resetModal() {
    const form = document.querySelector(CONFIG.selectors.form);
    const formState = document.querySelector(CONFIG.selectors.formState);
    const successState = document.querySelector(CONFIG.selectors.successState);
    const errorContainer = document.querySelector(CONFIG.selectors.errorContainer);

    if (form) form.reset();
    if (formState) formState.style.display = 'block';
    if (successState) successState.style.display = 'none';
    if (errorContainer) {
      errorContainer.textContent = '';
      errorContainer.style.display = 'none';
    }
    setSubmitting(false);
  }

  function setSubmitting(submitting) {
    isSubmitting = submitting;
    const submitBtn = document.querySelector(CONFIG.selectors.submitBtn);
    if (submitBtn) {
      submitBtn.disabled = submitting;
      const textEl = submitBtn.querySelector('.quote-form__submit-text');
      const loadingEl = submitBtn.querySelector('.quote-form__submit-loading');
      if (textEl) textEl.style.display = submitting ? 'none' : 'inline';
      if (loadingEl) loadingEl.style.display = submitting ? 'inline' : 'none';
    }
  }

  function showError(message) {
    const errorContainer = document.querySelector(CONFIG.selectors.errorContainer);
    if (errorContainer) {
      errorContainer.textContent = message;
      errorContainer.style.display = 'block';
    }
  }

  function showSuccess(reference) {
    const formState = document.querySelector(CONFIG.selectors.formState);
    const successState = document.querySelector(CONFIG.selectors.successState);
    const referenceDisplay = document.querySelector(CONFIG.selectors.referenceDisplay);

    if (formState) formState.style.display = 'none';
    if (successState) successState.style.display = 'block';
    if (referenceDisplay && reference) {
      referenceDisplay.textContent = reference;
    }
  }

  async function fetchCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch cart');
    return await response.json();
  }

  function validateForm(formData) {
    if (!formData.firstName.trim()) return ['First name is required'];
    if (!formData.lastName.trim()) return ['Last name is required'];
    if (!formData.email.trim()) return ['Email is required'];
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) return ['Please enter a valid email'];
    return [];
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (isSubmitting) return;

    const form = e.target;
    const errorContainer = document.querySelector(CONFIG.selectors.errorContainer);
    if (errorContainer) {
      errorContainer.textContent = '';
      errorContainer.style.display = 'none';
    }

    const formData = {
      firstName: form.querySelector('[name="firstName"]').value,
      lastName: form.querySelector('[name="lastName"]').value,
      email: form.querySelector('[name="email"]').value,
      phone: form.querySelector('[name="phone"]').value,
      company: form.querySelector('[name="company"]').value,
      notes: form.querySelector('[name="notes"]').value,
      honeypot: form.querySelector('[name="honeypot"]').value
    };

    const errors = validateForm(formData);
    if (errors.length > 0) {
      showError(errors[0]);
      return;
    }

    setSubmitting(true);

    try {
      const cart = await fetchCart();

      if (!cart.items || cart.items.length === 0) {
        showError('Your cart is empty. Please add items before requesting a quote.');
        setSubmitting(false);
        return;
      }

      const cartItems = cart.items.map(item => ({
        variant_id: item.variant_id,
        quantity: item.quantity,
        title: item.product_title,
        price: (item.price / 100).toFixed(2),
        properties: item.properties ? Object.entries(item.properties).map(([name, value]) => ({
          name,
          value: String(value)
        })) : []
      }));

      const payload = {
        customer: {
          email: formData.email,
          firstName: formData.firstName,
          lastName: formData.lastName,
          phone: formData.phone,
          company: formData.company,
          notes: formData.notes
        },
        cart: {
          items: cartItems,
          total_price: (cart.total_price / 100).toFixed(2)
        },
        honeypot: formData.honeypot
      };

      const response = await fetch(CONFIG.webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (response.ok && result.success) {
        showSuccess(result.draftOrderName || 'Submitted');
      } else {
        showError(result.message || 'An error occurred. Please try again.');
      }
    } catch (error) {
      console.error('Quote request error:', error);
      showError('Unable to submit your request. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
